import * as React from "react";

class DialogLText extends React.Component {
  constructor(props: {}) {
    super(props);
  }

  public render() {
    return (
      <svg
        className="dialogL-text dialogLMNO-text"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 140.7 106.1"
      >
        <g>
          <path
            fill="#FCF8ED"
            d="M60.7,45.7v15.4h-2v-0.6H47.9v0.6H46V45.7H60.7z M58.7,58.9V47.4H47.9v11.5H58.7z M58.2,51.2v1.1h-9.7v-1.1
			h3.9v-0.5h-2.5v-2.7h6.8v2.7h-2.6v0.5H58.2z M49.3,52.8h8v5.5h-8V52.8z M50.8,57.2h4.8v-3.3h-4.8V57.2z M51.5,49.6H55V49h-3.5
			V49.6z M51.5,54.4H55v2.3h-3.5V54.4z M52.6,55.8h1.2v-0.5h-1.2V55.8z"
          />
          <path
            fill="#FCF8ED"
            d="M71.4,51.2v0.6h5.5v1.2h-5.5v0.6h6.7v1.4H62.8v-1.4h6.6v-0.6H64v-1.2h5.4v-0.6h-5V50h5v-0.7h-6.6V48h6.6v-0.6
			h-4.8v-1.2h4.8v-1.1h2v1.1h4.8V48h2v1.4h-2v1.8H71.4z M64.9,55.6h11.4v5.5h-2.1v-0.5h-7.3v0.5h-2V55.6z M66.9,56.9v0.6h7.3v-0.6
			H66.9z M74.2,59.4v-0.7h-7.3v0.7H74.2z M71.4,48h2.8v-0.6h-2.8V48z M71.4,50h2.8v-0.7h-2.8V50z"
          />
          <path
            fill="#FCF8ED"
            d="M88.9,54.5v1h5.8v5.6h-1.8v-0.5h-4v0.6h-1.8V50.2h-0.9v-2.7l-0.7,1.2c-0.5-0.4-1.6-0.9-2.4-1.3
			c-0.3,0.3-0.6,0.7-0.9,1H85v1.3h-3v-1c-0.6,0.5-1.1,1-1.7,1.4c-0.1-0.4-0.5-1.4-0.8-1.8c1.3-0.8,2.7-2,3.4-3.4l1.6,0.6
			c-0.1,0.2-0.2,0.3-0.3,0.5c0.8,0.3,1.7,0.8,2.2,1.1h3.7c-0.2-0.5-0.5-1-0.7-1.4l1.8-0.7c0.3,0.6,0.8,1.3,1,1.8l-0.6,0.3h3.7v3.1
			h-1.4v4.3H88.9z M84.7,56.6c0.6,1.1,1.3,2.5,1.6,3.3l-1.5,0.7c-0.1-0.3-0.3-0.8-0.5-1.2c-3,1.1-3.6,1.4-3.9,1.7
			c-0.1-0.5-0.4-1.3-0.7-1.7c0.3-0.1,0.7-0.4,0.7-1v-8.1h5.3v6.1h-3.5v2.1l1.5-0.5c-0.1-0.3-0.3-0.6-0.4-0.9L84.7,56.6z M82.2,51.8
			v0.9H84v-0.9H82.2z M84,55v-0.9h-1.8V55H84z M87.9,48.7v1.1h5.6v-1.1H87.9z M92.2,51.4h-3.3v1.5h3.3V51.4z M88.9,57.2v1.7h4v-1.7
			H88.9z"
          />
        </g>
      </svg>
    );
  }
}

export default DialogLText;



// WEBPACK FOOTER //
// ./src/rabbitCity/components/DialogLText.tsx